var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightShort = function SvgArrowRightShort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.53 7.03a.75.75 0 0 0 0-1.06L7.757 1.197a.75.75 0 1 0-1.06 1.06L10.939 6.5l-4.242 4.243a.75.75 0 0 0 1.06 1.06zM0 7.25h12v-1.5H0z"
  })));
};
export default SvgArrowRightShort;